/**
 * mqimengweb  api
 */
let BASE_URL = '';

BASE_URL = process.env.VUE_APP_BUILD_ENV === 'test' ? 'https://test-qimeng.feihua100.com' : 'https://qimeng.feihua100.com';
if (process.env.NODE_ENV === 'development') {
    BASE_URL = 'https://test-qimeng.feihua100.com';
}

interface apiObject {
    [key: string]: any;
}

const api:apiObject = {
    // 退出登陆
    logout: `${BASE_URL}/api/feihua/v1/user/logOut`,


    // 分享学习报告页面
    studyReportSharePage: `${BASE_URL}/api/feihua/v2/course/shareDetail`,
    // 我的作品分享
    myWorkSharePage: `${BASE_URL}/api/feihua/v1/user/opus/shareDetail`,
    // APP下载版本获取
    appVerDownLoad: `${BASE_URL}/api/feihua/v1/pub/upgradShare`,
    weixin: {
        // 获取微信分享的配置信息
        config: `${BASE_URL}/api/feihua/v1/share/sign`
    },

    // 获取课程介绍
    courseIntroduction: `${BASE_URL}/api/feihua/v1/course/fetchCourseIntroduction`,

    // 支付相关
    wxH5Login: `${BASE_URL}/api/feihua/v1/user/wxH5Login`,
    sendMsgCode: `${BASE_URL}/api/feihua/v1/user/sendMsgCode`,
    sendLoginMsgCode: `${BASE_URL}/api/feihua/v1/user/sendLoginMsgCode`,
    loginBySms: `${BASE_URL}/api/feihua/v1/user/h5/loginBySms`,
    bookIdiomInfo: `${BASE_URL}/api/feihua/v1/user/bookIdiomInfo`,
    bindPhone: `${BASE_URL}/api/feihua/v1/user/bindPhone`,
    detail: `${BASE_URL}/api/feihua/v1/pay/h5/detail`,
    opti: `${BASE_URL}/api/feihua/v2/pay/h5/detail`,
    createOrder: `${BASE_URL}/api/feihua/v1/pay/h5/createOrder`,
    // 获取支付二维码
    getQR: `${BASE_URL}/api/feihua/v1/pay/h5/getThirdPayQueryForQr`,
    orderLoop: `${BASE_URL}/api/feihua/v1/pay/h5/order/loop`,
    orderList: `${BASE_URL}/api/feihua/v1/pay/h5/order/list`,
    refundReason: `${BASE_URL}/api/feihua/v1/order/refundApply`,
    refundOrder: `${BASE_URL}/api/feihua/v1/pay/h5/order/refundOrder`,
    obtainCoupon: `${BASE_URL}/api/feihua/v1/coupon/obtainCoupon`,
    wxH5LoginSimple: `${BASE_URL}/api/feihua/v1/user/wxH5LoginSimple`,
    expRightsReceive: `${BASE_URL}/api/feihua/v1/user/rights/expRightsReceive`,
    fetchTeacherInfo: `${BASE_URL}/api/feihua/v2/user/exp/fetchTeacherInfo`,
    fetchTeacherQcode: `${BASE_URL}/api/feihua/v2/user/exp/fetchTeacherQCode`,
    fetchUserStartDate: `${BASE_URL}/api/feihua/v2/user/exp/fetchUserStartDate`,
    invalidSource: `${BASE_URL}/api/feihua/v2/user/exp/invalidSource`,
    // 背诵分享页
    shareDetail: `${BASE_URL}/api/feihua/v1/picBook/recite/shareDetail`,
    // 优惠券
    activityExpired: `${BASE_URL}/api/feihua/v1/activity/isExpired`,
    activityMyDetail: `${BASE_URL}/api/feihua/v1/activity/pricingTestEntry`,
    // 兑换码
    payRedeem: `${BASE_URL}/api/feihua/v1/pay/redeem`,

    // 打卡0元学
    fetchClockType: `${BASE_URL}/api/feihua/v2/course/fetchClockType`,
    punchCardData: `${BASE_URL}/api/feihua/v1/course/dailyAttend/record`,
    cashDetail: `${BASE_URL}/api/feihua/v1/course/dailyAttend/withdrawCheck`,


    // 联合会员领取页面
    combinationInfo: `${BASE_URL}/api/feihua/v1/pay/order/combinationInfo`,
    openCombinationRight: `${BASE_URL}/api/feihua/v1/pay/order/openCombinationRight`,

    // 用户中心
    getUserInfo: `${BASE_URL}/api/feihua/v1/user/getUserInfo`,
    editUserInfo: `${BASE_URL}/api/feihua/v1/user/editUserInfo`,

    // 作品
    getOpusList: `${BASE_URL}/api/feihua/v2/user/opus/list`,
    deleteOpus: `${BASE_URL}/api/feihua/v2/user/opus/delete`,

    // 爱成语预约问卷提交接口
    preBook: `${BASE_URL}/api/feihua/v1/user/preBook`,

    // 单周卡领取接口
    receiveRights: `${BASE_URL}/api/feihua/v1/right/receiveRights`,
    // 个人信息页 - 获取用户基本资料
    personalInfo: `${BASE_URL}/api/feihua/v1/user/personalInfo`,
    // 个人信息页 - 导出个人信息到邮箱
    personalInfoExport: `${BASE_URL}/api/feihua/v1/user/personalInfo/export`
};

export default api;

